export default __webpack_public_path__ + "static/routing-374ec3b6476e3ee6aa8220745fc47e80.svg";